import { Base, createApp, importWhenVisible } from '@studiometa/js-toolkit';
import { Figure, Tabs } from '@studiometa/ui';
import { isDev } from './config.js';
import Popup from './components/Popup.js';
import Masonry from './components/Masonry.js';

/**
 * @typedef {{
 *   $children: {
 *     Figure: Figure[],
 *     Tabs: import('@studiometa/ui').Tabs[],
 *     Video: Array<Promise<import('./components/Video.js').default>>
 *     Accordion: Array<Promise<import('./components/Accordion.js').default>>
 *     Slider: Array<Promise<import('./components/Slider.js').default>>
 *     Countdown: Array<Promise<import('./components/Countdown.js').default>>
 *     FigureZoom: Array<Promise<import('./components/FigureZoom.js').default>>
 *     ParcoursTabs: Array<Promise<import('./components/ParcoursTabs.js').default>>
 *     Popup: Array<Promise<import('./components/Popup.js').default>>
 *   }
 * }} AppProps
 */

/**
 * App class.
 * @augments {Base<AppProps>}
 */
class App extends Base {
  /**
   * App config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'App',
    log: isDev(),
    components: {
      Figure,
      Tabs,
      Slider: () => importWhenVisible(() => import('./components/Slider.js'), 'Slider'),
      Video: () => importWhenVisible(() => import('./components/Video.js'), 'Video'),
      Accordion: () => importWhenVisible(() => import('./components/Accordion.js'), 'Accordion'),
      Countdown: () => importWhenVisible(() => import('./components/Countdown.js'), 'Countdown'),
      FigureZoom: () => importWhenVisible(() => import('./components/FigureZoom.js'), 'FigureZoom'),
      ParcoursTabs: () =>
        importWhenVisible(() => import('./components/ParcoursTabs.js'), 'ParcoursTabs'),
      Popup,
      Masonry,
    },
  };
}

export default createApp(App, {
  root: document.documentElement,
  screens: {
    '2xs': '0rem',
    xs: '30rem',
    s: '40rem',
    m: '48rem',
    l: '64rem',
    xl: '80rem',
    '2xl': '96rem',
    '3xl': '120rem',
  },
});
